var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(_vm.enabledContent)?_c('v-card',[(_vm.enabledHeader)?_c('v-card-title',[_vm._t("header")],2):_vm._e(),_vm._t("content")],2):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }